<div fxLayout="column" class="m-t">
    @for (ctrl of controls(); track $index) {
        <div
            data-testid="field-condition-element"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            class="p-t cipo--border-top--solid align-center">
            <span fxFlex="6" class="additional-margin-for-alignment">
                @if ($index === 0) {
                    {{ "complexConditions.general.if" | translate }}
                } @else {
                    {{ "complexConditions.general.andIf" | translate }}
                }
            </span>
            <div fxFlex fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
                <cipo-select
                    data-testid="field-condition-field-select"
                    fxFlex="0 1 25"
                    fxFlex.lt-xl="32"
                    fxFlex.lt-lg="48"
                    [control]="ctrl.fieldControl" />
                @if (ctrl.fieldControl.value) {
                    <cipo-select
                        data-testid="field-condition-operator-select"
                        fxFlex="0 1 25"
                        fxFlex.lt-xl="32"
                        fxFlex.lt-lg="48"
                        [control]="ctrl.operatorControl" />
                }
                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Number &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.TextOrNumber
                ) {
                    @if (ctrl.selectedOperatorId === OperatorTypeEnum.Between) {
                        <cipo-number
                            data-testid="field-condition-first-value"
                            fxFlex="1 1 23"
                            [control]="ctrl.controlNumber" />
                        <cipo-number
                            data-testid="field-condition-second-value"
                            fxFlex="1 1 23"
                            [control]="ctrl.secondControlNumber" />
                    } @else {
                        <cipo-number
                            data-testid="field-condition-number-value"
                            fxFlex="1 1 auto"
                            [control]="ctrl.controlNumber" />
                    }
                }
                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Text &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.TextOrNumber
                ) {
                    <cipo-text
                        data-testid="field-condition-text-value"
                        fxFlex="1 1 auto"
                        [control]="ctrl.controlText" />
                }
                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Text &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.Select
                ) {
                    @if (
                        !(
                            ctrl.selectedOperatorId === OperatorTypeEnum.IsEmpty ||
                            ctrl.selectedOperatorId === OperatorTypeEnum.IsNotEmpty
                        )
                    ) {
                        <cipo-select
                            data-testid="field-condition-select-value"
                            fxFlex="1 1 auto"
                            [control]="ctrl.valueControl" />
                    }
                }
                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Select &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.TextOrNumber
                ) {
                    <cipo-checkbox
                        data-testid="field-condition-checkbox-value"
                        fxFlex="0 1 auto"
                        [control]="ctrl.controlCheckbox" />
                }
            </div>
            <button
                data-testid="field-condition-delete-button"
                fxFlex="none"
                class="additional-margin-for-alignment"
                mat-icon-button
                [title]="'general.table.delete' | translate"
                [attr.aria-label]="'general.table.delete' | translate"
                (click)="deleteFieldCondition($index)">
                <mat-icon aria-hidden="true">delete</mat-icon>
            </button>
        </div>
        @if (
            ctrl.selectedOperatorId === OperatorTypeEnum.Between &&
            ctrl.secondControlNumber.hasError("secondLessThanFirst")
        ) {
            <div class="cipo--material--hint cipo-text--warn-900 m-t-xs m-l-sm">
                {{ "complexConditions.general.valuesValidation" | translate }}
            </div>
        }
    }
</div>
